<mat-dialog-content class="modal-header">
  <h2 mat-dialog-title>DOCUMENTO</h2>
</mat-dialog-content>

<mat-dialog-content class="modal-body">
  <div class="content">
    <div class="marco-visor">
      <div class="visor-pdf" *ngIf="esPDF">
        <pdf-viewer [src]="src" [render-text]="true" [original-size]="false" [autoresize]="true"></pdf-viewer>
      </div>
      <div class="visor-image" *ngIf="!esPDF">
        <img [src]="imagesrc">
      </div>
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end" class="modal-actions">
  <button class="btn btn-naranja" mat-raised-button (click)="descargar()">
    <mat-icon>cloud_download</mat-icon> Descargar
  </button>
  <button type="button" class="btn btn-naranja2" mat-button (click)="onNoClick()">
    <mat-icon>exit_to_app</mat-icon> Salir
  </button>
</mat-dialog-actions>